import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { fmt, fmtIDR } from "../lib/format";
import { CheckCircle2, XCircle, AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Modal } from "./OfficerHome";

export default function Approvals() {
  const [rows, setRows] = useState([]);
  const [reject, setReject] = useState(null);
  const load = () => api.get("/transactions/pending").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const approve = async (code) => {
    try { await api.post(`/transactions/${code}/approve`); toast.success("Disetujui & diproses"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2"><AlertTriangle className="h-6 w-6 text-amber-400" /><h1 className="font-head text-2xl font-bold">Approvals (Low Margin)</h1></div>

      {rows.length === 0 ? <div className="nnx-card p-8 text-center text-[#64748B]" data-testid="no-approvals">Tidak ada transaksi menunggu approval.</div> :
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          {rows.map((t) => (
            <div key={t.txn_code} className="nnx-card p-4 border-amber-500/40" data-testid={`approval-${t.txn_code}`}>
              <div className="flex justify-between items-center">
                <span className="mono text-sm">{t.txn_code}</span>
                <span className="text-xs text-amber-400">{t.type} · {t.pair}</span>
              </div>
              <div className="mt-2 text-sm space-y-1">
                <div className="flex justify-between"><span className="text-[#94A3B8]">Beri</span><span className="mono">{fmt(t.gives_amount, t.gives_asset)}</span></div>
                <div className="flex justify-between"><span className="text-[#94A3B8]">Terima</span><span className="mono">{fmt(t.receives_amount, t.receives_asset)}</span></div>
                <div className="flex justify-between"><span className="text-[#94A3B8]">Margin/unit</span><span className="mono text-amber-400">{fmtIDR(t.margin_per_unit)} (min {fmtIDR(t.min_margin)})</span></div>
                <div className="flex justify-between"><span className="text-[#94A3B8]">Est. Profit</span><span className="mono">{fmtIDR(t.net_profit)}</span></div>
                <div className="text-xs text-[#64748B]">Officer: {t.officer_name}</div>
              </div>
              <div className="flex gap-2 mt-3">
                <button className="btn-gold flex-1 flex items-center justify-center gap-1" data-testid={`approve-${t.txn_code}`} onClick={() => approve(t.txn_code)}><CheckCircle2 className="h-4 w-4" /> Approve</button>
                <button className="btn-outline flex-1 flex items-center justify-center gap-1 hover:border-rose-500/50 hover:text-rose-400" data-testid={`reject-${t.txn_code}`} onClick={() => setReject(t)}><XCircle className="h-4 w-4" /> Reject</button>
              </div>
            </div>
          ))}
        </div>}

      {reject && <RejectModal txn={reject} onClose={() => setReject(null)} onDone={() => { setReject(null); load(); }} />}
    </div>
  );
}

function RejectModal({ txn, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try { await api.post(`/transactions/${txn.txn_code}/reject`, { reason }); toast.success("Ditolak"); onDone(); }
    catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };
  return (
    <Modal title={`Reject ${txn.txn_code}`} onClose={onClose} testid="reject-modal">
      <textarea data-testid="reject-reason" className="nnx-input" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Alasan reject" />
      <button className="btn-gold w-full mt-4 bg-rose-500 hover:bg-rose-600 text-white" data-testid="confirm-reject" onClick={submit} disabled={loading}>{loading ? <Loader2 className="h-4 w-4 animate-spin inline" /> : "REJECT"}</button>
    </Modal>
  );
}
